
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns787fa14700266ec3b5fc5104f65097c6en from './en.yaml'
            i18n.addResourceBundle('en', '787fa14700266ec3b5fc5104f65097c6', flattenObject(ns787fa14700266ec3b5fc5104f65097c6en), true, true);
        
        export default '787fa14700266ec3b5fc5104f65097c6';
    